var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkSlashSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22620_323703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.848873 0.109691C0.621373 -0.0664808 0.29106 -0.0256605 0.111685 0.197777C-0.0676895 0.421214 -0.026127 0.745629 0.201373 0.9218L13.1514 10.8906C13.3789 11.0667 13.7092 11.0259 13.8886 10.8025C14.0679 10.579 14.0264 10.2546 13.7989 10.0784L10.7036 7.69582L12.6832 5.75149C13.9192 4.53762 13.9192 2.5718 12.6832 1.35793C11.5895 0.283715 9.86575 0.144066 8.60794 1.02707L8.57294 1.05071C8.25794 1.272 8.18575 1.70168 8.41106 2.00891C8.63637 2.31614 9.07387 2.38918 9.38669 2.16789L9.42169 2.14426C10.1239 1.65227 11.0842 1.72961 11.6923 2.32903C12.3814 3.00578 12.3814 4.10149 11.6923 4.77825L9.59231 6.84075L8.8945 6.30364C9.42606 5.14778 9.18981 3.76203 8.247 2.83606C7.10512 1.71243 5.30481 1.62864 4.06231 2.58469L0.848873 0.109691ZM5.22825 3.48059C5.88669 3.16047 6.70919 3.26789 7.25825 3.8093C7.69575 4.23899 7.85981 4.847 7.73294 5.40989L5.22825 3.48059ZM8.8945 8.94621L4.83231 5.8009C4.78637 6.65598 5.09919 7.5218 5.75544 8.16418C6.60637 8.99993 7.82044 9.25989 8.89669 8.94407L8.8945 8.94621ZM2.55075 4.03703L1.317 5.24875C0.0810605 6.46262 0.0810605 8.42844 1.317 9.64231C2.41075 10.7165 4.1345 10.8562 5.39231 9.97317L5.42731 9.94953C5.74231 9.72825 5.8145 9.29856 5.58919 8.99133C5.36387 8.6841 4.92637 8.61106 4.61356 8.83235L4.57856 8.85598C3.87637 9.34797 2.91606 9.27063 2.30794 8.67121C1.61887 7.99231 1.61887 6.89661 2.30794 6.21985L3.65981 4.89211L2.55294 4.03489L2.55075 4.03703Z",
    fill: "#F5222D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22620_323703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSlashSolid);
export default __webpack_public_path__ + "static/media/link-slash-solid.d132409b677473909794710b8f75617c.svg";
export { ForwardRef as ReactComponent };